import React from "react";
import { BooleanInput, NumberInput, SimpleForm, TextInput, useRecordContext } from "react-admin";
import Grid from "@mui/material/Grid";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";

const normalizeCode = (value: unknown) =>
  value == null ? value : String(value).trim().toUpperCase();

const validateRequired = (v: unknown) =>
  v == null || String(v).trim() === "" ? "Required" : undefined;

type FmbContributionCategoryFormProps = Omit<React.ComponentProps<typeof SimpleForm>, "children">;

export function FmbContributionCategoryForm(props: FmbContributionCategoryFormProps) {
  const record = useRecordContext();
  const isSystem = Boolean(record?.isSystem);

  return (
    <SimpleForm {...props} sx={{ maxWidth: 700 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput
            source="code"
            label="Code"
            fullWidth
            required
            disabled={isSystem}
            validate={validateRequired}
            parse={normalizeCode}
            helperText={
              isSystem
                ? "System category code cannot be modified"
                : "Must be unique, e.g. DEG, IFTAAR, RICE"
            }
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput source="name" label="Name" fullWidth required validate={validateRequired} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <NoArrowKeyNumberInput
            source="defaultUnitAmount"
            label="Default unit amount (₹)"
            fullWidth
            helperText="Optional default amount auto-filled when creating contributions"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <NumberInput source="sortOrder" label="Sort order" fullWidth defaultValue={0} />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <BooleanInput
            source="isActive"
            label="Active"
            defaultValue
            disabled={isSystem}
            helperText={isSystem ? "System categories cannot be deactivated" : false}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  );
}
